import { Component, Input, output, ChangeDetectionStrategy } from '@angular/core';

import type { ViewRecord } from '@core/views-types';
import type { LayoutListHeaderComponent } from '@core/views-util';

import { TableListGroupHeadingComponent } from '../table-list-group-heading/table-list-group-heading.component';

@Component({
  selector: 'rt-wrapped-table-list-group-heading',
  imports: [TableListGroupHeadingComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ` <rt-table-list-group-heading
    [state]="isCollapsed ? 'collapsed' : 'normal'"
    [name]="recordData.group!.label"
    [counter]="recordData.data?.meta?.totalCount ?? 0"
    [symbol]="recordData.group?.symbol ?? null"
    [withDivider]="withDivider"
    (click)="click.emit(recordData)"
  />`,
})
export class WrappedTableListGroupHeadingComponent implements LayoutListHeaderComponent<ViewRecord> {
  @Input() public recordData: LayoutListHeaderComponent<ViewRecord>['recordData'];
  @Input() public isCollapsed: boolean = false;
  @Input() public withDivider: boolean = true;

  public click = output<this['recordData']>();
}
